import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ErrorComponent } from '../shared/error/error.component';
import { GeneralInformationComponent } from '../shared/general-information/general-information.component';
import { AmountRequestComponent } from './amount-request/amount-request.component';
import { BackDocumentScanComponent } from './back-document-scan/back-document-scan.component';
import { DocumentScanSuccessComponent } from './document-scan-success/document-scan-success.component';
import { FingerPrintsScanComponent } from './finger-prints-scan/finger-prints-scan.component';
import { FrontDocumentScanComponent } from './front-document-scan/front-document-scan.component';
import { MaxPeriodRequestComponent } from './max-period-request/max-period-request.component';
import { MaxProductsErrorComponent } from './max-products-error/max-products-error.component';
import { MicroEvidenteMasterComponent } from './micro-evidente-master/micro-evidente-master.component';
import { MicroSimulatorComponent } from './micro-simulator/micro-simulator.component';
import { OneTimePasswordComponent } from './one-time-password/one-time-password.component';
import { OtpProblemComponent } from './otp-problem/otp-problem.component';
import { PoliticallyExposedPersonComponent } from './politically-exposed-person/politically-exposed-person.component';
import { ProcessComponent } from './process/process.component';
import { RequestComponent } from './request/request.component';

const routes: Routes = [
  {
    path: 'request',
    component: RequestComponent,
  },
  {
    path: 'back-document-scan',
    component: BackDocumentScanComponent,
  },
  {
    path: 'retry-back-document-scan',
    component: ErrorComponent,
  },
  {
    path: 'front-document-scan',
    component: FrontDocumentScanComponent,
  },
  {
    path: 'retry-front-document-scan',
    component: ErrorComponent,
  },
  {
    path: 'retry-finger-prints-scan',
    component: ErrorComponent,
  },
  {
    path: 'scan-attempts-ecxeeded',
    component: ErrorComponent,
  },
  {
    path: 'finger-prints-scan',
    component: FingerPrintsScanComponent,
  },
  {
    path: 'document-scan-success',
    component: DocumentScanSuccessComponent,
  },
  {
    path: 'pep-validation',
    component: PoliticallyExposedPersonComponent,
  },
  {
    path: 'prospect-is-pep',
    component: ErrorComponent,
  },
  {
    path: 'step-process',
    component: ProcessComponent,
  },
  {
    path: 'amount-request',
    component: AmountRequestComponent,
  },
  {
    path: 'max-period-request',
    component: MaxPeriodRequestComponent,
  },
  {
    path: 'max-products-error',
    component: MaxProductsErrorComponent,
  },
  {
    path: 'one-time-password',
    component: OneTimePasswordComponent,
  },
  {
    path: 'otp-problem',
    component: OtpProblemComponent,
  },
  {
    path: 'general-data-information',
    component: GeneralInformationComponent,
  },
  {
    path: 'micro-simulator',
    component: MicroSimulatorComponent,
  },
  {
    path: 'micro-evidente-master',
    component: MicroEvidenteMasterComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})

export class IdentificationRoutes { }
